import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ThemeProvider from './components/ThemeProvider';
import AppRoutes from './AppRoutes';

const App: React.FC = () => {
  return (
    <ThemeProvider defaultTheme="light" storageKey="egg-score-ui-theme">
      <Router>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
};

export default App;
